export default class End {
    get(frame) {
        if(frame.num === window.Json.game.length - 1 ) {
            return [window.Json.game.length - 15, window.Json.game.length, 5];
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/episods/all/end.js
 **/